module.exports = __webpack_public_path__ + "img/worklog.6a526ebc.png";